export default __webpack_public_path__ + "static/media/trailer-overlay-play-icon.9d66d46a.svg";